import React, { useEffect, useState } from "react";
import { Layout, Menu as AntMenu, Input, Space, Avatar } from "antd";
import { Link } from "react-router-dom";
import {
  LockOutlined,
  PushpinOutlined,
  PushpinFilled,
} from "@ant-design/icons";

import { IMAGE_BASE_URL } from "../../constants/api";
import assets from "../../utils/ImagesPath";
import LS_SERVICE from "../../utils/localStorage";
import { getAPI } from "../../utils/common";
import { APP_PAGE_LIST } from "../../constants/api";
import { DRAWER_MENU, USER_ACCESS } from "../../constants/constent";

const { Sider } = Layout;
const { SubMenu } = AntMenu;

const siderStyle = {
  overflow: "auto",
  height: "95vh",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
};

const menuCategories = DRAWER_MENU;

function Drawer() {
  const [collapsed, setCollapsed] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [appPages, setAppPages] = useState([]);
  const [pinnedItems, setPinnedItems] = useState(LS_SERVICE.getPinnedMenu());

  const userType = LS_SERVICE.get("user_type");
  const allowedKeys =
    USER_ACCESS[userType] === "all" ? "all" : USER_ACCESS[userType] || [];

  const settings = LS_SERVICE.get("setting") || {};
  const { logo, favicon } = settings;
  const logoSrc = logo
    ? `${IMAGE_BASE_URL}${collapsed ? favicon : logo}`
    : assets.logo;

  const togglePin = (item) => {
    let updated;

    const exists = pinnedItems.find((x) => x.key === item.key);

    if (exists) {
      updated = pinnedItems.filter((x) => x.key !== item.key);
    } else {
      updated = [...pinnedItems, item];
    }

    setPinnedItems(updated);
    LS_SERVICE.setPinnedMenu(updated);

    // realtime update event
    window.dispatchEvent(
      new CustomEvent("pinnedMenuUpdated", { detail: updated }),
    );
  };

  useEffect(() => {
    const updatePinned = (e) => {
      setPinnedItems(e.detail);
    };

    window.addEventListener("pinnedMenuUpdated", updatePinned);

    return () => {
      window.removeEventListener("pinnedMenuUpdated", updatePinned);
    };
  }, []);

  const filteredMenuCategories = menuCategories
    .map(({ category, icon, items, moduleFlag }) => {
      // Hide the entire category when its module is disabled
      const categoryModuleEnabled = moduleFlag ? !!settings[moduleFlag] : true;

      if (!categoryModuleEnabled) {
        return {
          category,
          icon,
          items: [],
        };
      }

      return {
        category,
        icon,
        items: items.filter((item) => {
          const matchesSearch = item.label
            .toLowerCase()
            .includes(searchTerm.toLowerCase());

          const hasAccess =
            allowedKeys === "all" || allowedKeys.includes(item.key);

          // Hide individual items when their module is disabled
          const moduleEnabled = item.moduleFlag
            ? !!settings[item.moduleFlag]
            : true;

          return matchesSearch && hasAccess && moduleEnabled;
        }),
      };
    })
    .filter(({ items }) => items.length > 0);

  React.useEffect(() => {
    getAPI(
      APP_PAGE_LIST,
      (res) => {
        if (res.status === true) {
          setAppPages(res.data);
        }
      },
      () => {},
    );
  }, []);

  const isRouteEnabled = (route) => {
    const page = appPages.find((p) => p.route === route);
    return page ? page.is_enabled : true; // default allow
  };

  return (
    <Sider
      width={320}
      style={siderStyle}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div style={{ padding: "10px" }}>
        <img className="logo" src={logoSrc} alt="Logo" />
        <br />
        <Input
          placeholder="Search menu"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <AntMenu
        theme="light"
        mode="inline"
        defaultSelectedKeys={["dashboard"]}
        // defaultOpenKeys={["Dashboard"]}
        // defaultOpenKeys={filteredMenuCategories.map((cat) => cat.category)}
      >
        {filteredMenuCategories.map(({ category, icon, items }) => (
          <SubMenu key={category} title={category} icon={icon}>
            {items.map(({ key, icon, label, to }) => {
              const enabled = isRouteEnabled(to);

              return (
                <AntMenu.Item
                  key={key}
                  icon={
                    enabled ? icon : <LockOutlined style={{ color: "red" }} />
                  }
                >
                  {enabled ? (
                    <Space
                      style={{
                        width: collapsed ? "auto" : "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <Link to={to}>{label}</Link>
                      <Avatar
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();

                          togglePin({
                            key,
                            label,
                            to,
                            icon,
                          });
                        }}
                      >
                        {pinnedItems.some((x) => x.key === key) ? (
                          <PushpinFilled
                            style={{ color: "var(--primary-color)" }}
                          />
                        ) : (
                          <PushpinOutlined />
                        )}
                      </Avatar>
                    </Space>
                  ) : (
                    <span style={{ color: "#999" }}>{label}</span>
                  )}
                </AntMenu.Item>
              );
            })}
          </SubMenu>
        ))}
      </AntMenu>
    </Sider>
  );
}

export default Drawer;
